<template>
  <div class="risk-control-content">
    <Card shadow>
      <Row :gutter="18">
        <Col span="7" style="display:none">
          <label style="display: flex; align-items: center">
            <span style="width: 80px">代理组:</span>
            <Select
              v-model="table.params.platid"
              filterable
              placeholder="筛选所属平台"
              @on-change="updatePlatCheckList"
            >
              <Option
                v-for="(item, index) in plat_list"
                :value="item.id"
                :label="item.name"
                :key="index"
              >
                {{ item.name }}
                <span style="color: #bbb">({{ item.id }})</span>
              </Option>
            </Select>
          </label>
        </Col>
        <Col span="4">
          <label style="display: flex; align-items: center">
            <span style="width: 50px">代理:</span>
            <Select
              v-model="table.params.app_id"
              filterable
              clearable
              placeholder="筛选代理"
              id="l-data-record-mulsel"
              @on-change="updateSelect"
            >
              <Option
                v-for="(item, index) in all_app_list"
                :value="item.appid"
                :label="item.appName"
                :key="index"
              >
                {{ item.appName }}
                <span style="color: #bbb">({{ item.appid }})</span>
              </Option>
            </Select>
          </label>
        </Col>
        <Col span="5">
          <label style="display: flex; align-items: center">
            <span style="width: 120px">风控策略:</span>
            <Select
              v-model="table.params.stock_ids"
              filterable
              placeholder="筛选风控策略"
              clearable
              multiple
              :max-tag-count="3"
            >
              <Option
                v-for="(item, index) in select.exec_strategy_list"
                :value="item.id"
                :label="item.name"
                :key="index"
              >
                {{ item.name }}
                <span style="color: #bbb">({{ item.id }})</span>
              </Option>
            </Select>
          </label>
        </Col>
        <Col span="5">
          <label style="display: flex; align-items: center">
            <span style="width: 120px">统计时间:</span>
            <DatePicker
              type="date"
              v-model="select.dataTime"
              placeholder="统计时间"
              :options="dateOptions"
            ></DatePicker>
          </label>
        </Col>
        <Col span="4" style="display: flex; justify-content: space-between">
          <Button type="primary" @click.native="TransTopReq()">查询</Button>
        </Col>
      </Row>
    </Card>
    <div style="margin-top: 12px">
      <Select
        v-model="select.chartCheck"
        filterable
        @on-change="updateChartCheck"
        style="width: 200px"
        v-show="imageData.chartData.rows.length > 0"
      >
        <Option
          v-for="(item, index) in select.chartColumn"
          :value="item.value"
          :label="item.name"
          :key="index"
          >{{ item.name }}</Option
        >
      </Select>
      <ve-line
        :data="imageData.chartData"
        :settings="imageData.chartSetting"
        :extend="imageData.extend"
        :ref="imageData.ref"
        height="500px"
        style="width: 100%"
        v-if="imageData.chartData.columns.length > 1"
      ></ve-line>
      <div v-else style="height: 300px; width: 100%"></div>
    </div>
    <Table
      border
      :columns="table.columns"
      :data="table.data"
      :max-height="720"
    ></Table>
    <Page
      show-total
      show-sizer
      v-show="table.data.length"
      style="margin-top: 12px"
      :page-size-opts="[20, 40, 60, 80]"
      :page-size="table.params.param._param.page_size"
      :total="table.total"
      :current="table.params.param._param.page"
      @on-change="ChangePage"
      @on-page-size-change="ChangePageSize"
    />
    <Modal v-model="riskModel.show" width="500">
      <p slot="header" style="color: #1c2438; text-align: center">
        <span>策略配置详情</span>
      </p>
      <div>
        <Form :label-width="220">
          <FormItem label="风控名称：">
            <span>{{ riskModel.data.risk_name }}</span>
          </FormItem>
          <FormItem label="风控标签：">
            <span>{{ getTagName(riskModel.data.tag) }}</span>
          </FormItem>
          <FormItem label="风控类型/风控方式：">
            <span>
              <span
                :style="{ color: getRiskModeColor(riskModel.data.sys_type) }"
                >{{ getRiskMode(riskModel.data.sys_type) }}</span
              >&nbsp;/&nbsp;
              <span
                :style="{ color: getRiskWayColor(riskModel.data.risk_mode) }"
                >{{ getRiskWay(riskModel.data.risk_mode) }}</span
              >
            </span>
          </FormItem>
          <FormItem label="库存周期：">
            <span>{{
              ['', '小时库存', '天库存', '周库存', '月库存'][
                riskModel.data.stock_period
              ]
            }}</span>
          </FormItem>
          <FormItem label="风控杀/送概率：">
            <span>{{
              (riskModel.data.risk_rate || 0) +
                '% / ' +
                (riskModel.data.risk_rate_give || 0) +
                '%'
            }}</span>
          </FormItem>
          <FormItem label="基础库存：">
            <span>{{ riskModel.data.stock_base }}</span>
          </FormItem>
          <FormItem label="盈亏率下限/上限：">
            <span>{{
              (riskModel.data.profit_low || 0) +
                '% /' +
                (riskModel.data.profit_upper || 0) +
                '%'
            }}</span>
          </FormItem>
          <FormItem label="风控/PVP/玩家阈值：">
            <span>{{
              (riskModel.data.game_pros || 0) / 100 +
                '% / ' +
                (riskModel.data.pvp_pros || 0) / 100 +
                '% / ' +
                (riskModel.data.user_pros || 0) / 100 +
                '%'
            }}</span>
          </FormItem>
          <FormItem label="单机游戏杀率/送率：">
            <span>{{
              (riskModel.data.single_kill || 0) / 100 +
                '% / ' +
                (riskModel.data.single_give || 0) / 100 +
                '%'
            }}</span>
          </FormItem>
          <!-- <FormItem label="生效时间："><span>{{riskModel.data.update_time}}</span></FormItem>-->
        </Form>
      </div>
      <div slot="footer" style="display: none"></div>
    </Modal>
    <Modal v-model="stockModel.show" width="450">
      <p slot="header" style="color: #1c2438; text-align: center">
        <span>投注库存增减量</span>
      </p>
      <div>
        <Form :label-width="150">
          <FormItem label="投注库存增减量">
            <InputNumber
              v-model="stockModel.val.a_stock"
              style="width: 200px"
            ></InputNumber>
          </FormItem>
        </Form>
      </div>
      <div slot="footer">
        <Button type="warning" @click="closeStock">取消</Button>
        <Button type="success" @click="updateStock">提交</Button>
      </div>
    </Modal>
  </div>
</template>

<script>
import { GetAppGameRisks, GetAppTagList, TransTopReq } from '@/api/admin/risk'
import moment from 'moment'
export default {
  name: 'RiskContorlTrend',
  data() {
    return {
      select: {
        app_list: [],
        risk_tags_list: [],
        exec_strategy_list: [],
        dataTime: this.getCurrentZeroDay(),
        chartColumn: [
          { value: 0, name: '策略杀送趋势' },
          { value: 1, name: '策略盈亏率趋势' }
        ],
        chartCheck: 0
      },
      zeroIdMap: {},
      lowUpArray: {},
      imageDataString: {},
      allColumn: [],
      imageValue: [],
      imageData: {
        show: false,
        app_name: '',
        ref: 'vChartImage',
        extend: {
          tooltip: {
            position: (point, params, dom, rect, size) => {
              return [
                Math.min(size.viewSize[0] - size.contentSize[0], point[0]),
                point[1]
              ]
            },
            formatter: e => {
              let arr = []
              let str = e.reduce((res, cur, index) => {
                if (index == 0) res += cur.name + '<br>'
                if (cur.value[1] !== null) {
                  let isPre = cur.seriesName.includes('盈亏率')
                  let pre = isPre ? '%' : ''
                  let pVal = isPre
                    ? (cur.value[1] * 100).toFixed(2)
                    : cur.value[1] || 0
                  res +=
                    cur.marker + cur.seriesName + ': ' + pVal + `${pre}<br>`
                }
                if (cur.seriesName.includes('库存盈亏率')) {
                  arr.push(cur.seriesName)
                }
                return res
              }, '')
              if (this.select.chartCheck == 1) {
                str += this.getUpAndLow(arr)
              }
              return str
            }
          },
          series: { symbolSize: 1, smooth: false, connectNulls: true }
        },
        chartSetting: {
          yAxisType: ['normal', 'percent'],
          axisSite: { right: [] },
          scale: [true, true]
        },
        chartData: {
          columns: ['time', ''],
          rows: []
        }
      },
      stockModel: {
        show: false,
        val: { a_stock: 0, id: 0, app_id: 0 },
        params: {
          mod: 'root',
          platid: 20,
          stock_ids: [],
          app_id: 0,
          app_ids: [],
          app_name: '',
          platform: 0,
          param: {
            _mod: 'root',
            _func: 'UpdateGameRiskStock',
            _param: {
              platid: 20,
              app_id: 588,
              app_ids: [],
              id: 5,
              stock: 0,
              start: 0,
              end: 0,
              general: -1,
              pack_no: -1
            }
          }
        }
      },
      riskModel: { show: false, data: {} },
      table: {
        total: 0,
        params: {
          mod: 'root',
          platid: 20,
          stock_ids: [],
          app_ids: [],
          app_id: 0,
          app_name: '',
          platform: 0,
          param: {
            _mod: 'root',
            _func: 'GetGameRiskList',
            _param: {
              platid: 20,
              app_id: 0,
              game_id: 0,
              page: 1,
              page_size: 20,
              tag: 0,
              stock_ids: [],
              app_ids: [],
              start: 0,
              end: 0,
              general: -1,
              pack_no: -1
            }
          }
        },
        data: [],
        columns: [
          { type: 'index', title: '序号', width: 60, align: 'center' },
          {
            key: 'use_app_name',
            width: 80,
            resizable: true,
            align: 'center',
            renderHeader: (h, params) =>
              this.renderHeader(h, '所属盘口', '显示该风控策略所属盘口;')
          },
          {
            key: 'risk_name',
            width: 80,
            resizable: true,
            align: 'center',
            render: (h, params) => {
              return h(
                'span',
                {
                  style: { cursor: 'pointer', color: '#2d8cf0' },
                  on: {
                    click: e => {
                      this.handleTableClick(params.row)
                    }
                  }
                },
                params.row.risk_name || ''
              )
            },
            renderHeader: (h, params) =>
              this.renderHeader(
                h,
                '风控名称',
                '显示该风控策略名称，点击统计项，显示该风控策略的配置详情'
              )
          },
          {
            key: 'stock_start_time',
            align: 'center',
            width: 110,
            resizable: true,
            sortable: true,
            render: (h, params) =>
              h('span', (params.row.stock_start_time || 0) + '点'),
            renderHeader: (h, params) =>
              this.renderHeader(h, '库存开始时间', '显示库存开始时间;')
          },
          {
            key: 'bet_stock',
            align: 'center',
            width: 110,
            resizable: true,
            sortable: true,
            renderHeader: (h, params) =>
              this.renderHeader(
                h,
                '投注金额',
                '显示该策略所属子游戏筛选时间内的投注金额;'
              )
          },
          {
            key: 'pro_loss_stock',
            width: 110,
            resizable: true,
            align: 'center',
            sortable: true,
            renderHeader: (h, params) =>
              this.renderHeader(
                h,
                '盈亏金额',
                '显示该策略所属子游戏筛选时间内的盈亏金额;'
              )
          },
          {
            key: 'a_stock',
            width: 80,
            resizable: true,
            sortable: true,
            align: 'center',
            render: (h, params) => {
              return h(
                'div',
                {
                  style: {
                    cursor: 'pointer',
                    color: '#2d8cf0',
                    padding: '5px 0'
                  },
                  on: {
                    click: e => {
                      this.stockModel.show = true
                      let { id, a_stock, app_id } = params.row

                      this.stockModel.val = { ...params.row }
                    }
                  }
                },
                params.row.a_stock
              )
            },
            renderHeader: (h, params) =>
              this.renderHeader(
                h,
                '调整库存',
                '显示临时调整库存，点击后弹窗库存输入配置框'
              )
          },
          {
            title: '盈亏率',
            key: 'win_pros',
            sortable: true,
            align: 'center',
            width: 80,
            resizable: true,
            render: (h, params) =>
              h('div', [
                h(
                  'span',
                  { style: 'color:#ed4014;' },
                  params.row.profit_low + '%'
                ),
                h('span', ' / '),
                h(
                  'span',
                  { style: 'color:#19be6b;' },
                  params.row.profit_upper + '%'
                )
              ])
          },
          {
            title: '基础库存',
            key: 'stock_base',
            sortable: true,
            align: 'center',
            width: 150,
            resizable: true,
            render: (h, params) =>
              h('div', [
                h('span', params.row.stock_base),
                h(
                  'span',
                  { style: { color: '#ed4014' } },
                  ` (${params.row.real_bet_stock}/${params.row.real_hit_stock})`
                )
              ]),
            renderHeader: (h, params) =>
              this.renderHeader(
                h,
                '基础库存',
                '预防初始生成数据时盈亏税收比出现较大的波动影响大盘的风控'
              )
          },
          {
            key: 'win_pros',
            sortable: true,
            align: 'center',
            width: 120,
            resizable: true,
            render: (h, params) => {
              let num1 = Number((params.row.win_pros / 100).toFixed(2))
              let num2 = Number((params.row.stock_win_pros / 100).toFixed(2))
              let num3 = Number((params.row.profit_low / 100).toFixed(2))
              let num4 = Number((params.row.profit_upper / 100).toFixed(2))
              let arr = []
              arr.push(h('span', num1 + '% / '))
              if (num2 > num4) {
                arr.push(h('span', { style: 'color:#ed4014;' }, num2 + '%'))
              } else if (num2 < num3) {
                arr.push(h('span', { style: 'color:#19be6b;' }, num2 + '%'))
              } else {
                arr.push(h('span', num2 + '%'))
              }
              return h('div', arr)
            },
            renderHeader: (h, params) =>
              this.renderHeader(
                h,
                '游戏/库存盈亏率',
                '（大盘投注金额-大盘返奖金额）/大盘投注金额'
              )
          },
          {
            key: 'game_num',
            width: 110,
            resizable: true,
            sortable: true,
            align: 'center',
            renderHeader: (h, params) =>
              this.renderHeader(
                h,
                '游戏次数',
                '统计筛选时间内，该策略下游戏进行的游戏次数，包含正常、判定杀、判定送'
              )
          },
          {
            key: 'all_sum',
            width: 110,
            resizable: true,
            sortable: true,
            align: 'center',
            renderHeader: (h, params) =>
              this.renderHeader(
                h,
                '总风控次数',
                '显示当前策略在筛选时间内，总共触发的风控次数，判定杀次数+判定送次数;'
              )
          },
          {
            key: 'kill_sum',
            width: 110,
            resizable: true,
            sortable: true,
            align: 'center',
            renderHeader: (h, params) =>
              this.renderHeader(
                h,
                '判定杀次数',
                '显示当前策略在筛选时间内，总共触发判定杀次数;'
              )
          },
          {
            key: 'real_kill_sum',
            width: 110,
            resizable: true,
            sortable: true,
            align: 'center',
            renderHeader: (h, params) =>
              this.renderHeader(h, '杀成功次数', '判定杀时，成功杀的次数;')
          },
          {
            key: 'kill_sum',
            width: 110,
            resizable: true,
            sortable: true,
            align: 'center',
            render: (h, params) =>
              h(
                'span',
                (
                  (params.row.game_num
                    ? params.row.kill_sum / params.row.game_num
                    : 0) * 100
                ).toFixed(2) + '%'
              ),
            renderHeader: (h, params) =>
              this.renderHeader(h, '杀风控力度', '杀判定次数 / 游戏次数')
          },
          {
            key: 'give_sum',
            width: 110,
            resizable: true,
            sortable: true,
            align: 'center',
            renderHeader: (h, params) =>
              this.renderHeader(
                h,
                '判定送次数',
                '显示当前策略在筛选时间内，总共触发判定送次数;'
              )
          },
          {
            key: 'real_give_sum',
            width: 110,
            resizable: true,
            sortable: true,
            align: 'center',
            renderHeader: (h, params) =>
              this.renderHeader(h, '送成功次数', '判定送时，成功送的次数;')
          },
          {
            key: 'give_sum',
            minWidth: 80,
            sortable: true,
            align: 'center',
            render: (h, params) =>
              h(
                'span',
                (
                  (params.row.game_num
                    ? params.row.give_sum / params.row.game_num
                    : 0) * 100
                ).toFixed(2) + '%'
              ),
            renderHeader: (h, params) =>
              this.renderHeader(h, '送风控力度', '送判定次数 / 游戏次数')
          }
        ]
      }
    }
  },
  methods: {
    handleTableClick(row) {
      this.riskModel.data = row
      this.riskModel.show = true
    },
    getRandomId() {
      let newAppId = Math.ceil(
        Math.random() * 10000000000000000 - 1000000000000000
      )
      if (this.zeroIdMap[newAppId] === 0) {
        this.getRandomId()
      } else {
        this.zeroIdMap[newAppId] = 0
        return newAppId
      }
    },
    getPlatId(appid) {
      let item = this.select.app_list.find(el => el.appid == appid)
      return item ? item.platform : 0
    },
    updateSelect(val) {
      this.table.params.stock_ids = []
      this.GetAppGameRisks()
    },
    updatePlatCheckList() {
      let index = this.select.app_list.findIndex(
        el => el.platform == this.table.params.platid
      )
      if (index == -1) {
        this.table.params.app_id = 0
      } else {
        this.table.params.app_id = this.select.app_list[index].appid
      }
      this.table.params.stock_ids = []
      this.GetAppGameRisks()
    },
    closeStock() {
      this.stockModel.show = false
    },
    updateChartCheck() {
      this.updateRows()
      this.imageData.chartData.columns = this.updateChartColumn()
    },
    updateRows() {
      this.imageData.chartData.rows = this.imageValue[this.select.chartCheck]
    },
    updateChartColumn() {
      let isNormal = this.select.chartCheck == 0
      this.imageData.chartSetting.yAxisType = [isNormal ? 'normal' : 'percent']
      let arr = this.allColumn.filter(el => isNormal != el.includes('盈亏率'))
      arr = ['time', ...arr]
      return arr
    },
    //修改库存增减量
    updateStock() {
      this.stockModel.params.param._param.app_id = this.stockModel.val.app_id
      this.stockModel.params.platid = this.table.params.param._param.platid
      this.stockModel.params.app_id = this.stockModel.val.app_id
      this.stockModel.params.param._param.platid = this.table.params.param._param.platid
      this.stockModel.params.param._param.id = this.stockModel.val.id
      this.stockModel.params.param._param.stock = this.stockModel.val.a_stock
      TransTopReq({ ...this.stockModel.params }).then(res => {
        this.$Message.success('修改成功')
        this.closeStock()
        this.TransTopReq()
      })
    },
    GetAppGameRisks() {
      GetAppGameRisks({
        app_ids: [this.zeroIdMap[this.table.params.app_id]],
        platid: this.table.params.platid
      }).then(res => {
        this.select.exec_strategy_list = res._param.data || []
      })
    },
    TransTopReq() {
      this.table.params.param._param.start = this.getSecond(
        this.select.dataTime
      )
      this.table.params.param._param.end = this.getSecond(
        this.select.dataTime,
        false
      )
      this.table.params.param._param.stock_ids = this.copyData(
        this.table.params.stock_ids
      )
      let app_id = this.zeroIdMap[this.table.params.app_id]
      if (this.table.params.app_id === undefined) {
        app_id = 0
        this.table.params.platid = 1
      }
      let appList = [app_id]
      this.table.params.app_ids = appList
      this.table.params.param._param.stock_ids = [
        ...this.table.params.stock_ids
      ]
      this.table.params.param._param.platid = this.table.params.platid
      this.table.params.param._param.app_id = app_id
      this.table.params.param._param.app_ids = appList
      let params = this.copyData(this.table.params)
      params.app_id = app_id
      this.imageData.chartData.rows = []
      this.imageDataString = {}
      this.imageData.chartData.columns = []
      TransTopReq(params).then(res => {
        let arr = res._param.data || []
        this.table.total = res._param.total
        if (arr) {
          let rows = {}
          let columnArray = []
          let rows1 = {}
          let lowUpArray = {}
          for (let i = 0; i < arr.length; i++) {
            let el = arr[i]
            // 游戏盈亏 字段
            el.game_num = el.show_data.game_num || 0

            el.pro_loss_stock =
              Math.round((el.bet_stock - el.hit_stock) / 100) / 100
            el.bet_stock = Math.round(el.bet_stock / 100) / 100
            el.a_stock = el.a_stock || 0
            el.kill_sum = 0
            el.give_sum = 0
            el.real_kill_sum = 0
            el.real_give_sum = 0
            el.profit_low = el.profit_low / 100
            el.profit_upper = el.profit_upper / 100
            let item = el.show_data
            if (item) {
              el.kill_sum = item.kill_sum || 0
              el.real_kill_sum = item.real_kill_sum || 0
              el.real_give_sum = item.real_give_sum || 0
              el.give_sum = item.give_sum || 0
            }
            el.all_sum = el.kill_sum + el.give_sum
            el.game_risk_rate = el.game_num
              ? (el.kill_sum + el.give_sum) / el.game_num
              : 0
            let app = this.select.app_list.find(
              element => el.use_app_id == element.appid
            )
            let appName = app ? app.appName : ''
            el.use_app_name = `${appName}(${el.use_app_id})`
            this.updateImageDetail2(
              rows,
              lowUpArray,
              columnArray,
              rows1,
              el,
              params.param._param.start
            )
          }
          this.lowUpArray = lowUpArray
          this.allColumn = columnArray
          this.imageValue = [Object.values(rows1), Object.values(rows)]
          this.updateChartCheck()
          let ref = this.$refs[this.imageData.ref]
          ref && ref.echarts.resize()
          this.table.data = arr
        }
      })
    },
    getTagName(val) {
      let find = this.select.risk_tags_list.find(el => el.id == val)
      if (find) return find.tag_name
      return ''
    },

    getRiskModeColor(val) {
      return ['#333', 'red', '#32CD32', ''][val] || ''
    },
    getRiskMode(val) {
      return ['自动', '杀', '送', '关闭'][val] || ''
    },
    getRiskWayColor(val) {
      return ['#2db7f5', '#ff9900'][val] || ''
    },
    getRiskWay(val) {
      return ['库存盈亏', '营收比'][val]
    },
    getUpAndLow(arr) {
      return arr.reduce((res, cur) => {
        res += this.imageDataString[cur]
        return res
      }, '')
    },
    //策略杀送
    updateImageDetail(rows, columnArray, el) {},
    //策略盈亏
    updateImageDetail2(rows, lowUpArray, columnArray, rows1, el, stime) {
      let low = el.profit_low
      let upper = el.profit_upper
      let type = el.risk_name + '库存盈亏率'
      let type1 = el.risk_name + '真实盈亏率'
      let data = el.show_data
      let killType = el.risk_name
      columnArray.push(killType + '杀')
      columnArray.push(killType + '送')
      let lines = { kill_data: '杀', give_data: '送' }
      this.imageDataString[type] =
        `<span style="display:inline-block;margin-right:5px;border-radius:10px;width:10px;height:10px;background-color:transparent;"></span>` +
        el.risk_name +
        '盈亏率阈值下限/上限：' +
        low +
        '% / ' +
        upper +
        '%<br>'
      columnArray.push(type)
      columnArray.push(type1)
      for (let i = 0; i < 480; i++) {
        let timeInt = stime * 1000 + i * 180000
        let timeValue = moment(timeInt)
          .locale('zh-cn')
          .format('HH:mm')
        let searchTime = moment(timeInt)
          .locale('zh-cn')
          .format('YYYY-MM-DD HH:mm:ss')
        let element = data.stock_win_pros
          ? data.stock_win_pros.find(elItem => elItem.t == searchTime)
          : null
        let element1 = data.win_pros
          ? data.win_pros.find(elItem => elItem.t == searchTime)
          : null
        rows[timeValue] = rows[timeValue] || {}
        rows[timeValue][type] = element ? element.v / 10000 : 0
        rows[timeValue][type1] = element1 ? element1.v / 10000 : 0
        rows[timeValue].time = timeValue
        if ((i * 3) % 10 > 7 || (i * 3) % 10 == 0) {
          let count = 10 - ((i * 3) % 10)
          count = count > 3 ? 0 : 3
          let newTimeInt = count * 60 * 1000 + timeInt
          let newTimeValue = moment(newTimeInt)
            .locale('zh-cn')
            .format('HH:mm')
          let newSearchTime = moment(newTimeInt)
            .locale('zh-cn')
            .format('YYYY-MM-DD HH:mm:ss')
          let item = rows1[newTimeValue] || { time: newTimeValue }
          for (let k in lines) {
            let find
            if (data && data[k]) {
              find = data[k].find(elItem => elItem.t == newSearchTime)
            }
            item[killType + lines[k]] = find ? find.v : 0
          }
          rows1[newTimeValue] = item
        }
      }
      return rows
    },

    ChangePage(page) {
      this.table.params.param._param.page = page
      this.table.data = []
      this.TransTopReq()
    },
    ChangePageSize(page_size) {
      this.table.params.param._param.page = 1
      this.table.params.param._param.page_size = page_size
      this.table.data = []
      this.TransTopReq()
    },
    GetAppTagList() {
      GetAppTagList({
        sale_type: -1,
        tag_type: 'risk_tag',
        page: 1,
        page_size: 10000
      }).then(res => {
        this.select.risk_tags_list = res._param.List || []
      })
    },
    initFunc() {
      this.table.params.platid = this.getinitPlatId()
      let app_list = this.all_app_list.map(el => {
        let item = this.copyData(el)
        // if (!item.appid) {
        //   let newAppId = this.getRandomId()
        //   item.appid = newAppId
        // } else {
        //   this.zeroIdMap[item.appid] = item.appid
        // }
        this.zeroIdMap[item.appid] = item.appid
        return item
      })
      this.select.app_list = app_list
      let app = this.select.app_list.find(
        el => el.platform == this.table.params.platid
      )
      if (app) {
        this.table.params.app_id = app.appid
      }
      this.GetAppGameRisks()
      this.TransTopReq()
    }
  },
  created() {
    this.GetAppTagList()
    this.initFunc()
  }
}
</script>

<style scoped lang="less">
  .risk-control-content {
    height: 100%;
  overflow: auto;
  }
</style>
